export const DEFAULT_CHAT_ACCESS_GATE = {
  requireChatMembership: false,
  accessTelegramChatId: "",
  accessTelegramChatTitle: "",
  accessMaxChatId: "",
  accessMaxChatTitle: "",
};

export function readChatAccessGateFromSettings(gameSettings) {
  const settings = gameSettings ?? {};
  return {
    requireChatMembership: Boolean(settings.requireChatMembership),
    accessTelegramChatId: String(settings.accessTelegramChatId ?? "").trim(),
    accessTelegramChatTitle: String(settings.accessTelegramChatTitle ?? "").trim(),
    accessMaxChatId: String(settings.accessMaxChatId ?? "").trim(),
    accessMaxChatTitle: String(settings.accessMaxChatTitle ?? "").trim(),
  };
}

export function mergeChatAccessGateIntoSettings(settings, gatePatch = {}) {
  const current = readChatAccessGateFromSettings(settings);
  const next = { ...current, ...gatePatch };

  return {
    ...settings,
    requireChatMembership: Boolean(next.requireChatMembership),
    accessTelegramChatId: String(next.accessTelegramChatId ?? "").trim().slice(0, 120),
    accessTelegramChatTitle: String(next.accessTelegramChatTitle ?? "").trim().slice(0, 120),
    accessMaxChatId: String(next.accessMaxChatId ?? "").trim().slice(0, 40),
    accessMaxChatTitle: String(next.accessMaxChatTitle ?? "").trim().slice(0, 120),
  };
}
